import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import ControlMainPage from "./ControlMainPage";

const PaineldeControle = () => {
    const match = useRouteMatch();

    return(
        <Switch>
            <Route path={`${match.path}`} exact component={ControlMainPage} />
            <Redirect path="*" to="/" />
        </Switch>
        )
};

export default PaineldeControle;